







































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Home extends Vue {
  trackEvent (eventType: string) {
    if(window.wcs && window._nasa) {
      window._nasa["cnv"] = window.wcs.cnv(eventType, "1"); // 전환유형, 전환가치 설정해야함. 설치매뉴얼 참고}
      window.wcs.inflow();
      window.wcs_do(window._nasa);
    }
  }
}
